import React from "react";
import { Table } from "react-bootstrap";

const DATABASE_TAB = "database";

const errorSummary = (count) => `${count} ${count === 1 ? "error" : "errors"}; nothing was written`;

/** The errors of a refused upload, in the order the server reported them. */
export const ImportErrors = ({ errors }) => (
  <div className="mt-4">
    <p>{errorSummary(errors.length)}</p>
    <Table striped bordered size="sm" aria-label="Errors">
      <thead>
        <tr>
          <th>Tab</th>
          <th>Row</th>
          <th>Column</th>
          <th>Set</th>
          <th>Question</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        {errors.map((error, index) => (
          <tr key={index}>
            <td>{error.file ?? DATABASE_TAB}</td>
            <td>{error.row ?? ""}</td>
            <td>{error.column ?? ""}</td>
            <td>{error.set_key ?? ""}</td>
            <td>{error.question_key ?? ""}</td>
            <td>{error.message}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);
